import {
  IMAGE_COMPRESS_QUALITIES,
  IMAGE_COMPRESS_SCALE_FACTORS,
  IMAGE_UPLOAD_MAX_BYTES,
} from './constants';

export type CompressCanvasOptions = {
  onStillOversized?: () => void;
};

function canvasToJpegBlob(canvas: HTMLCanvasElement, quality: number): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('图片压缩失败'));
          return;
        }
        resolve(blob);
      },
      'image/jpeg',
      quality,
    );
  });
}

/** 在 Canvas 上按缩放比例与 JPEG 质量迭代压缩，优先返回不超过上限的结果。 */
export async function compressImageElementOnCanvas(
  image: HTMLImageElement,
  options?: CompressCanvasOptions,
): Promise<Blob> {
  const sourceWidth = image.naturalWidth;
  const sourceHeight = image.naturalHeight;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('无法创建画布上下文');
  }

  let smallestBlob: Blob | null = null;

  for (const scale of IMAGE_COMPRESS_SCALE_FACTORS) {
    const width = Math.max(1, Math.round(sourceWidth * scale));
    const height = Math.max(1, Math.round(sourceHeight * scale));
    canvas.width = width;
    canvas.height = height;
    context.drawImage(image, 0, 0, width, height);

    for (const quality of IMAGE_COMPRESS_QUALITIES) {
      const blob = await canvasToJpegBlob(canvas, quality);
      if (!smallestBlob || blob.size < smallestBlob.size) {
        smallestBlob = blob;
      }
      if (blob.size <= IMAGE_UPLOAD_MAX_BYTES) {
        return blob;
      }
    }
  }

  if (!smallestBlob) {
    throw new Error('图片压缩失败');
  }

  if (smallestBlob.size > IMAGE_UPLOAD_MAX_BYTES) {
    options?.onStillOversized?.();
  }

  return smallestBlob;
}
